import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vllag6pj: FaireBrandEntity = {
  token: "b_vllag6pj",
  type: "brand",
  name: "Trek Light",
  avatarUrl:
    "https://cdn.faire.com/fastly/8f14bf1809ac4e834a5942b00b694b0d84f2aeb7e70a8b3fa32ef4d8f2826cf6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b1c9a7a771abaf9d407be06fb1d209e41c6b6c8cea88f7683304b3aa06058d58.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8f14bf1809ac4e834a5942b00b694b0d84f2aeb7e70a8b3fa32ef4d8f2826cf6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b1c9a7a771abaf9d407be06fb1d209e41c6b6c8cea88f7683304b3aa06058d58.jpeg",
  location: "Boulder, CO, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 347,
  isTopShop: true,
  isInsider: true,
  description:
    "Trek Light is the husband and wife team of Seth & Heather Haber. Founded in 2003 in Boulder, CO, we began with a simple mission: to build a business with heart.\n\nA business that would be centered on happiness, a business that would give back with every sale, and one that would inspire its customers to share that happiness with others.\n\nOr, in seven words: Feel Good. Do Good. Pass It On.\n\nWe make products designed to follow you through life - inspired by our love of the outdoors, live music, cozy living spaces, and great design.\n\nThanks for being part of our story.\nThanks for supporting a business with heart.\nAnd thanks for being you.\n\nP.S. If we've connected with you in the past, please use our Faire Direct link to make your purchase & help us get the most from your order!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:36.473Z",
    importedBy: "entity-db-cli",
  },
};
